<template>
    <div class="table">
        <div class="container">
            <div class="handle-box">
                <el-form :model="queryCondition" :label-position="labelPosition" label-width="110px">
                    <el-row :gutter="16">
                        <el-col :span="8">
                            <el-form-item label="库存节点编号">
                                <el-input class="handle-input" v-model="queryCondition.mateName" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="库存节点名称">
                                <el-input class="handle-input" v-model="queryCondition.mateCode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="料架唯一编号">
                                <el-input class="handle-input" v-model="queryCondition.mateCode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="16">
                        <el-col :span="8">
                            <el-form-item label="料架类型编号">
                                <el-input class="handle-input" v-model="queryCondition.mateCode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="料架类型名称">
                                <el-input class="handle-input" v-model="queryCondition.mateCode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-button type="primary" @click="queryData">搜索</el-button>
                            <el-button type="primary">重置</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <el-row class="action-btn-row">
                <el-button type="primary" @click="downloadMatePart">下载</el-button>
            </el-row>
            <el-table :data="tableData" border highlight-current-row class="table">
                <el-table-column show-overflow-tooltip prop="mateCode" label="库存节点编码"></el-table-column>
                <el-table-column show-overflow-tooltip prop="no" label="库存节点名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="mateName" label="料架类型编码"></el-table-column>
                <el-table-column show-overflow-tooltip prop="createDate" label="料架类型名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="料架唯一编号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="当前节点状态"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination  @current-change="handleCurrentChange" layout="prev, pager, next" :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'abnormal-mate',
        data() {
            return {
                tableData: [{
                    mateCode: '123456',
                    no: '00000000',
                    mateName: 'red',
                    createDate: '2019-09-09',
                    status: '9999'
                }],
                total: 0,
                labelPosition: 'right',
                queryCondition:{
                    mateCode: '',
                    status: '',
                    date: '',
                    materialNo: '',
                    materialName: ''
                },
                applyForm: {
                    mateCode: '',
                    mateName: '',
                    applyCount: 0
                },
                applyDialog: false
            }
        },
        methods: {
            queryData(){
                console.dir(this.queryCondition);
            },
            /**
             * 翻页事件
             */
            handleCurrentChange(){

            },
            downloadMatePart(){

            }
        }
    }
</script>
<style scoped>
    .handle-input{
        width: 90%;
    }
    .action-btn-row{
        margin-bottom: 10px;
        margin-top: 10px;
    }
</style>